import { ReqX } from "IZOX/STATIC";

class Login {

  static async ReCAPTCHA(token){
    return await ReqX.SendBE("/CommonAPI/ReCAPTCHA/Verify", 
      {
        token
      }, null, null);
  }

  static async SignIn({email, password}){
    return await ReqX.SendBE("/CommonAPI/Auth/SignIn", 
      {
        username: email, 
        password
      }, null, null);
  }

  static async ForgotPassword({email}){
    return await ReqX.SendBE("/CommonAPI/Auth/ForgotPassword", 
      {
        username: email, 
      }, null, null);
  }

}

export default Login;